import React, {useState} from "react";
import {updateMemberPerkItem} from "../../common/api/WebApi";
import {CONSTANTS} from "../../common/constants";
import {InputAdornment} from "@mui/material";
import MDButton from "../../../components/MDButton";
import TextField from "@mui/material/TextField";
import {formatCurrency} from "../Utils";

export default function CartPerks({client, cart, getCartFullFn}) {

  const togglePerk = (item) => {
    item.applied = !!!item.applied;
    updateMemberPerkItem(client?.guid, item).then((resp) => {
      getCartFullFn()
    });
  }

  const displayPerk = (perk) => {
    return perk.name;
  }

  const applyPerkCredit = (item) => {
    let _item = {...item};
    _item.creditApplied = parseFloat(_item.creditApplied);

    updateMemberPerkItem(client?.guid, _item).then((resp) => {
      getCartFullFn()
    });

  }

  const [perkCreditValue, setPerkCreditValue] = useState(undefined)
  const [appliedPerkDiscount, setAppliedPerkDiscount] = useState(0);

  const [renderIndex, setRenderIndex] = useState(1);
  const perkValueChange = (perk, value, warn) => {
    let _cart = {...cart};
    _cart.memberPerks.map((p, idx) => {
      if (perk.id === p.id) {
        perk.creditApplied = value;
        perk.perkWarning = null;
        if (warn) {
          perk.perkWarning = warn;
        }
      }
    });
    setRenderIndex(renderIndex + 1)
  }

  return (
    <>{cart && cart?.memberPerks
      .sort((a, b) => a.id - b.id)
      .map((item, index) => {
        return (
          <div className={'psb-bordered my-2'} key={index} style={{
            background: '#f6f1f1',
            padding:'12px 20px 2px 20px'
          }}>
            <h6>
              You have a Member Perk available
            </h6>
            <p>
              <small>
                <b>Perk Type:</b> {displayPerk(item)}
                <br/>
                {item?.storeCreditBalance && <>
                  <b>Balance:</b> {formatCurrency(item?.storeCreditBalance)}
                  <br/>
                </>}
                {item?.perkType?.id !== CONSTANTS.PERK_TYPE.CREDIT &&
                  <MDButton className={'mt-3'} color="secondary" size={'small'} onClick={()=>{
                    togglePerk(item);
                  }}>Apply member perk</MDButton>
                }
              </small>
            </p>

            {item?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT && <>
              {renderIndex > 0 && <>
                <div className="input-group my-2">
                  <TextField type={'number'} step={"0.01"}
                           value={appliedPerkDiscount}
                           placeholder={'Credit amount'}
                           onChange={(e) => {
                             let target = 0;
                             try {
                               target = parseFloat(e.target.value);
                             } catch (err) {
                               target = 0;
                             }

                             let perkWarn = null;
                             if (target < parseFloat(item.storeCreditValue)) {
                               setAppliedPerkDiscount(target);
                             } else if (target > parseFloat(item.storeCreditValue)) {
                               setAppliedPerkDiscount(item.storeCreditValue);
                               perkWarn = 'Amount entered exceeds allowed value';
                             } else {
                               setAppliedPerkDiscount(target);
                               let perkWarn = null;
                             }
                             perkValueChange(item, target, perkWarn);
                           }}
                           InputProps={{
                             inputProps: { max: parseFloat(item?.storeCreditValue), step: 0.01 },
                             startAdornment: <InputAdornment position="start">
                               <b>$</b>
                             </InputAdornment>,
                           }}/>

                  <button className="btn btn-secondary" type="button" onClick={() => {
                    applyPerkCredit(item)
                  }}
                          style={{
                            border: 'solid 1px #ddd'
                          }}
                          id="button-addon1">Apply
                  </button>
                  {item?.perkWarn}
                </div>
              </>}

            </>
            }
          </div>
        )
      })
    }
    </>
  )
}